// In dev, Vite proxies /api → http://localhost:8000 (see vite.config.ts).
// In production, VITE_API_URL is set at build time.
const BASE_URL: string = import.meta.env.VITE_API_URL ?? "";

export class ApiError extends Error {
	constructor(
		public status: number,
		public data: unknown,
	) {
		super(`API Error ${status}`);
	}
}

export async function request<T>(
	path: string,
	options?: RequestInit,
): Promise<T> {
	const token = localStorage.getItem("token");
	const isFormData = options?.body instanceof FormData;
	const res = await fetch(`${BASE_URL}${path}`, {
		...options,
		headers: {
			// Let the browser set Content-Type for FormData (needed for multipart boundary)
			...(isFormData ? {} : { "Content-Type": "application/json" }),
			...(token ? { Authorization: `Bearer ${token}` } : {}),
			...options?.headers,
		},
	});
	if (!res.ok) {
		const data = await res.json().catch(() => ({}));
		if (res.status === 401) {
			window.dispatchEvent(new Event("auth:expired"));
		}
		throw new ApiError(res.status, data);
	}
	if (res.status === 204) return undefined as T;
	return res.json();
}
